<template>
  <v-layout style="align-items: center">
    <v-flex>
      <h1 class="title my-4">
        Game Setting / {{ input.id ? `${input.name}` : `Create Campaign` }}
      </h1>
    </v-flex>
    <v-flex class="text-xs-right" shrink>
      <v-btn color="green" class="mb-2 white--text" @click="handleSaveDraft">
        <v-icon class="mr-2">save</v-icon>{{ $t('Save') }}
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ['input'],
  methods: {
    handleSaveDraft() {
      this.$emit('handleSaveDraft')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/generalixwarroom/GameSetting/GameSettingTitle.vue